(function () {
  function startTypewriter(root) {
    if (!root) return;

    var el = root.querySelector(".typewriter-text");
    if (!el) return;

    if (root.__aphagoRunning) return;
    root.__aphagoRunning = true;

    var ctaWrap = document.querySelector("[data-aphago-cta]");
    var ctaLabel = ctaWrap ? ctaWrap.querySelector(".typewriter-cta__label") : null;

    // CTA: não aparece de uma vez — vamos digitar também
    if (ctaWrap) ctaWrap.classList.remove("is-visible");
    if (ctaLabel) ctaLabel.innerHTML = "";

    // Texto principal (com pausas [[p=...]] e <strong>/<br>)
    var story =
  "Você não entrou aqui por <strong>acaso</strong>.<br>" +
  "Não foi <strong>curiosidade</strong>.<br>" +
  "Muito menos promessa de <strong>desconto</strong>.<br>" +
  "Foi <strong>outra coisa</strong> 👀." +
  "[[p=900]]<br><br>" +

  "Sabe quando algo faz você parar, mesmo sem saber explicar direito?" +
  "[[p=800]]<br><br>" +

  "É estranho como a gente reconhece certos lugares...<br>" +
  "sem nunca ter estado neles." +
  "[[p=700]]<br><br>" +

  "Talvez porque falem a <strong>nossa língua</strong>.<br>" +
  "Ou porque lembram daquilo que a gente anda deixando pra depois<br>" +
  "no meio da correria da vida." +
  "[[p=900]]<br><br>" +

  "Você não está procurando só um <strong>produto premium personalizado</strong>." +
  "[[p=700]]<br><br>" +

  "Você está tentando segurar um <strong>momento</strong><br>" +
  "que passou rápido demais." +
  "[[p=850]]<br><br>" +

  "Uma risada boba.<br>" +
  "Um abraço que virou <strong>porto seguro</strong>.<br>" +
  "Um olhar que dizia tudo, sem dizer nada." +
  "[[p=900]]<br><br>" +

  "Tem gente que entra na nossa vida e vira casa 🏠.<br>" +
  "Muda a rotina.<br>" +
  "Muda a bagunça.<br>" +
  "Muda até o jeito da gente existir." +
  "[[p=1100]]<br><br>" +

  "E, quando a gente vê…<br>" +
  "esses momentos já viraram <strong>história</strong>." +
  "[[p=900]]<br><br>" +

  "O problema é que a vida não avisa.<br>" +
  "Ela passa. Ela corre. Ela <strong>atropela</strong>." +
  "[[p=1100]]<br><br>" +

  "E se a gente não cuida,<br>" +
  "essas histórias viram só <strong>lembrança</strong>." +
  "[[p=950]]<br><br>" +

  "Daquelas que a gente jura que nunca vai esquecer…<br>" +
  "e um dia esquece 😶." +
  "[[p=1300]]<br><br>" +

  "Talvez seja por isso que você esteja aqui agora." +
  "[[p=900]]<br><br>" +

  "Não pra comprar alguma coisa.<br>" +
  "Mas pra não deixar alguém ir embora." +
  "[[p=1200]]<br>" +

  "Um momento.<br>" +
  "Uma história.<br>" +
  "Um <strong>pedaço</strong> da sua própria vida." +
  "[[p=1400]]<br><br>" +

  "<strong>Fica</strong> mais um pouco 🤍." +
  "[[p=1200]]<br><br>" +

  "Nem tudo aqui faz sentido pra todo mundo.<br>" +
  "Mas algumas coisas…<br>" +
  "parecem que estavam esperando exatamente por você." +
  "[[p=1000]]<br><br>" +

  "E talvez — só talvez —<br>" +
  "esse seja o motivo de você estar aqui agora.";


    // CTA final digitada também
    var ctaText = "Escolha a coleção abaixo que mais combina com você.";

    // Ajuste de “humanização”
    var baseSpeed = 34;     // mais lento que antes
    var jitter = 22;        // variação por caractere (humano)
    var extraPunct = 160;   // pausa extra por pontuação
    var extraBreak = 260;   // pausa extra em <br>
    var extraSpace = 10;    // micro-pausa no espaço

    function rand(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    function speedForChar(ch) {
      var s = baseSpeed + rand(-jitter, jitter);
      if (s < 10) s = 10;

      // “respira” mais em pontuação
      if (ch === "." || ch === "!" || ch === "?" ) s += extraPunct + rand(0, 140);
      if (ch === "," || ch === ";" || ch === ":") s += Math.floor(extraPunct * 0.7) + rand(0, 90);
      if (ch === "—") s += extraPunct + rand(120, 220);
      if (ch === " ") s += extraSpace;

      return s;
    }

    function readPauseAt(str, idx) {
      if (!str.startsWith("[[p=", idx)) return null;
      var end = str.indexOf("]]", idx);
      if (end === -1) return null;
      var token = str.slice(idx, end + 2);
      var m = token.match(/\[\[p=(\d+)\]\]/);
      if (!m) return null;
      return { ms: parseInt(m[1], 10), len: token.length };
    }

    function typeHTML(targetEl, str, onDone) {
      var i = 0;
      targetEl.innerHTML = "";

      function step() {
        if (i >= str.length) return onDone && onDone();

        // pausa explícita [[p=...]]
        var p = readPauseAt(str, i);
        if (p) {
          i += p.len;
          return setTimeout(step, p.ms);
        }

        // injeta tag HTML inteira (<strong>, </strong>, <br>)
        if (str[i] === "<") {
          var close = str.indexOf(">", i);
          if (close !== -1) {
            var tag = str.slice(i, close + 1);
            targetEl.innerHTML += tag;
            i = close + 1;

            // pausa extra em quebra de linha pra ficar dramático
            if (tag.toLowerCase() === "<br>") {
              return setTimeout(step, extraBreak + rand(0, 120));
            }
            return setTimeout(step, 0);
          }
        }

        var ch = str[i];
        targetEl.innerHTML += ch;
        i++;

        setTimeout(step, speedForChar(ch));
      }

      step();
    }

    function typePlain(targetEl, str, onDone) {
      var i = 0;
      targetEl.innerHTML = "";

      function step() {
        if (i >= str.length) return onDone && onDone();
        var ch = str[i];
        targetEl.innerHTML += ch;
        i++;
        setTimeout(step, speedForChar(ch));
      }

      step();
    }

    // roda: texto principal -> CTA digitada
    typeHTML(el, story, function () {
      root.__aphagoRunning = false;

      if (!ctaWrap || !ctaLabel) return;

      // mostra o bloco e digita a CTA
      ctaWrap.classList.add("is-visible");
      typePlain(ctaLabel, ctaText);
    });
  }

  function boot() {
    var root = document.querySelector("[data-aphago-tw]");
    if (root) startTypewriter(root);
  }

  // Roda mesmo se DOM já estiver pronto
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  // Theme editor
  document.addEventListener("shopify:section:load", boot);
})();
